<template>
  <UserActivityView>
    <ActivityInfo v-if="isActivityGoalEnabled" />
    <MyActivity />
  </UserActivityView>
</template>

<script>
import { mapGetters } from 'vuex';
import ActivityInfo from '@/components/pages/UserActivity/ActivityInfo.vue';
import MyActivity from '@/components/pages/UserActivity/MyActivity.vue';
import UserActivityView from '@/components/pages/UserActivity/UserActivity.vue';
import pageCommonMixin from '@/components/mixins/pageCommonMixin';
export default {
  name: 'UserActivityPage',
  components: { ActivityInfo, UserActivityView, MyActivity },
  mixins: [pageCommonMixin],
  computed: {
    ...mapGetters('ContextStore', ['isActivityGoalEnabled'])
  }
};
</script>
